import React, { useState } from "react";
import useHistory from "routing/useHistory";
import ArchiveIndexSet from "archive/components/ArchiveIndexSet/ArchiveIndexSet";
import { Row, Col, Button, ButtonToolbar } from "components/bootstrap";
import { ConfirmDialog, DocumentTitle, IfPermitted, PageHeader } from "components/common";
import IndicesPageNavigation from "components/indices/IndicesPageNavigation";
import DocsHelper from "util/DocsHelper";
import ArchiveRoutes from "archive/Routes";
import useArchiveIndexSetRangesMutation from "archive/hooks/useArchiveIndexRangesMutation";
const ArchiveIndexSetPage = () => {
  const [showConfirmRecalculateDialog, setShowConfirmRecalculateDialog] = useState(false);
  const { push } = useHistory();
  const { rebuildArchiveIndexSetRangesMutation } = useArchiveIndexSetRangesMutation();
  const handleRecalculate = () => {
    setShowConfirmRecalculateDialog(true);
  };
  const recalculateRanges = () => {
    rebuildArchiveIndexSetRangesMutation().then(() => {
      setShowConfirmRecalculateDialog(false);
    });
  };
  const cancelRecalculate = () => {
    setShowConfirmRecalculateDialog(false);
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Index Set: Restored Archives" }, /* @__PURE__ */ React.createElement(IndicesPageNavigation, null), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Index Set: Restored Archives",
      documentationLink: {
        title: "Index model documentation",
        path: DocsHelper.PAGES.INDEX_MODEL
      },
      topActions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["indexsets:edit"] }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => push(ArchiveRoutes.INDEX_SET.CONFIGURATION) }, "Edit Index Set")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: ["indexranges:rebuild"] }, /* @__PURE__ */ React.createElement(Button, { onClick: handleRecalculate }, "Recalculate Index Ranges")))
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(ArchiveIndexSet, null)))), showConfirmRecalculateDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmRecalculateDialog,
      title: "Recalculating Index Ranges",
      onCancel: cancelRecalculate,
      onConfirm: recalculateRanges
    },
    /* @__PURE__ */ React.createElement("p", null, "This will recalculate index ranges for this index set using a background system job. Do you want to proceed?")
  ));
};
export default ArchiveIndexSetPage;
